import React, { useRef } from 'react';
import { connect } from 'react-redux';

import Logo from '../../Assets/Logos/WapinaApina.png';
import './WapinaLogo.css';
import { toggleAdminMode } from '../../store/actions/index';

const LONG_PRESS_MS = 700;

const WapinaLogo = ({ isAdmin, adminMode, onToggleAdminMode }) => {
  const timerRef = useRef(null);

  const startPress = (e) => {
    if (!isAdmin) return;
    e.preventDefault();
    timerRef.current = setTimeout(() => {
      onToggleAdminMode();
      timerRef.current = null;
    }, LONG_PRESS_MS);
  };

  const cancelPress = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  return (
    <div
      className={`Logo${adminMode ? ' Logo--admin' : ''}`}
      onPointerDown={startPress}
      onPointerUp={cancelPress}
      onPointerLeave={cancelPress}
      onPointerCancel={cancelPress}
      onContextMenu={(e) => e.preventDefault()}
    >
      <img src={Logo} alt="Radio Wapina" draggable={false} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  isAdmin: state.auth.isAdmin,
  adminMode: state.auth.adminMode,
});

const mapDispatchToProps = (dispatch) => ({
  onToggleAdminMode: () => dispatch(toggleAdminMode()),
});

export default connect(mapStateToProps, mapDispatchToProps)(WapinaLogo);
